<template>
    <div class="weeduc-admin-page corporate-page corporate-settings-page text-start p-0">
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    :title="t.empresa.title"
                    :subtitle="t.empresa.subtitle"
                    :hasMargin="false"
                />
            </div>
            <div class="weeduc-admin-page__header-actions">
                <v-btn
                    color="primary"
                    variant="flat"
                    rounded="lg"
                    class="text-none"
                    :loading="saving"
                    :disabled="!canEdit || loading"
                    @click="save"
                >
                    <v-icon class="me-1" size="small">mdi-content-save</v-icon>
                    {{ t.common.save }}
                </v-btn>
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div v-if="!canEdit" class="corporate-settings-banner">
                {{ t.empresa.readOnly }}
            </div>

            <div class="weeduc-admin-page__panel">
                <div v-if="loading" class="corporate-placeholder">
                    <Loader :isActive="false" />
                </div>
                <div v-else-if="error" class="corporate-placeholder">{{ t.common.error }}</div>

                <template v-else>
                    <section class="corporate-settings-section">
                        <p class="corporate-section-label">{{ t.empresa.sectionIdentity }}</p>
                        <v-row class="corporate-settings-row">
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="form.tradeName"
                                    :label="t.empresa.legalName"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="form.name"
                                    :label="t.empresa.tradeName"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="form.idFiscal"
                                    :label="t.empresa.idFiscal"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" md="5">
                                <v-text-field
                                    v-model="form.email"
                                    :label="t.empresa.email"
                                    type="email"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" sm="6" md="2">
                                <v-text-field
                                    v-model="form.phone"
                                    :label="t.empresa.phone"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" sm="6" md="2">
                                <v-text-field
                                    v-model="form.color"
                                    :label="t.empresa.color"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                        </v-row>

                        <p class="corporate-section-label">{{ t.empresa.sectionAddress }}</p>
                        <v-row class="corporate-settings-row">
                            <v-col cols="12" sm="4" md="2">
                                <v-text-field
                                    v-model="form.postcode"
                                    :label="t.empresa.postcode"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" sm="5" md="8">
                                <v-text-field
                                    v-model="form.address"
                                    :label="t.empresa.address"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-text-field
                                    v-model="form.addressNumber"
                                    :label="t.empresa.addressNumber"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.addressComplement"
                                    :label="t.empresa.addressComplement"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.neighborhood"
                                    :label="t.empresa.neighborhood"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="form.city"
                                    :label="t.empresa.city"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="6" md="2">
                                <v-text-field
                                    v-model="form.county"
                                    :label="t.empresa.county"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="6" md="2">
                                <v-text-field
                                    v-model="form.country"
                                    :label="t.empresa.country"
                                    variant="outlined"
                                    density="compact"
                                    class="inputd weeduc-admin-v-field"
                                    :disabled="!canEdit"
                                    hide-details="auto"
                                />
                            </v-col>
                        </v-row>
                    </section>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TitlePage from '@/components/Weflix/titlePage.vue';
import Loader from '@/components/Loader/loader.vue';
import { corporateI18n } from '@/i18n/mixins';
import companyApi from '@/utils/company';
import { canConfigureCorporate } from '@/utils/corporate/permissions';
import { resetCorporateSettingsCache } from '@/utils/corporate/bootstrap';
import {
    ADMIN_DASHBOARD_MODE,
    setAdminDashboardMode,
} from '@/utils/corporate/adminDashboardMode';

const toCorporateBool = (company) => {
    if (!company || typeof company !== 'object') return false;
    if (company.typeBusiness === 2 || company.typeBusiness === '2') return true;
    if (company.typeBusiness === 1 || company.typeBusiness === '1') return false;
    return company.isCorporate === true || company.isCorporate === 1 || company.isCorporate === '1';
};

const emptyForm = () => ({
    id: null,
    name: '',
    tradeName: '',
    idFiscal: '',
    email: '',
    phone: '',
    color: '',
    imagePath: null,
    imageFinalPath: '',
    country: '',
    county: '',
    city: '',
    address: '',
    addressNumber: '',
    addressComplement: '',
    postcode: '',
    neighborhood: '',
});

export default {
    name: 'CorporateSettings',
    mixins: [corporateI18n],
    components: { TitlePage, Loader },
    data() {
        return {
            loading: true,
            saving: false,
            error: false,
            form: emptyForm(),
            companySnapshot: null,
        };
    },
    computed: {
        ...mapState(['token', 'company']),
        canEdit() {
            return canConfigureCorporate();
        },
    },
    async created() {
        await this.load();
    },
    methods: {
        ...mapActions(['storeCompany']),
        pickCompanySource(companyData) {
            const company = companyData && typeof companyData === 'object' && !Array.isArray(companyData)
                ? companyData
                : {};
            return {
                ...emptyForm(),
                ...company,
                name: company.name || '',
                tradeName: company.tradeName || company.name || '',
                imageFinalPath: company.imageFinalPath || company.imagePath || '',
                phone: company.phone || '',
            };
        },
        async load() {
            this.loading = true;
            this.error = false;
            try {
                const companyData = await companyApi.getInfoCompany(this.token);
                this.companySnapshot = companyData;
                this.form = this.pickCompanySource(companyData);
                this.storeCompany({ company: companyData });
            } catch (e) {
                const fromStore = this.company && typeof this.company === 'object' && !Array.isArray(this.company)
                    ? this.company
                    : null;
                if (fromStore?.id || fromStore?.name) {
                    this.companySnapshot = fromStore;
                    this.form = this.pickCompanySource(fromStore);
                } else {
                    this.error = true;
                }
            } finally {
                this.loading = false;
            }
        },
        buildCompanyPayload() {
            const base = this.companySnapshot && typeof this.companySnapshot === 'object'
                ? { ...this.companySnapshot }
                : {};
            return {
                ...base,
                name: this.form.name,
                tradeName: this.form.tradeName,
                idFiscal: this.form.idFiscal,
                email: this.form.email,
                phone: this.form.phone || null,
                color: this.form.color,
                imageFinalPath: this.form.imageFinalPath || null,
                imagePath: this.form.imagePath || null,
                country: this.form.country,
                county: this.form.county,
                city: this.form.city,
                address: this.form.address,
                addressNumber: this.form.addressNumber,
                addressComplement: this.form.addressComplement,
                postcode: this.form.postcode,
                neighborhood: this.form.neighborhood,
            };
        },
        async save() {
            if (!this.canEdit) return;
            this.saving = true;
            try {
                const updatedCompany = await companyApi.setInfoCompany(
                    this.token,
                    this.buildCompanyPayload(),
                );
                this.companySnapshot = updatedCompany;
                const corporate = toCorporateBool(updatedCompany);
                this.storeCompany({
                    company: {
                        ...updatedCompany,
                        isCorporate: corporate,
                        platform_type: corporate ? 'corporate' : 'school',
                    },
                });
                this.form = this.pickCompanySource(updatedCompany);
                setAdminDashboardMode(
                    corporate
                        ? ADMIN_DASHBOARD_MODE.CORPORATIVO
                        : ADMIN_DASHBOARD_MODE.ESCOLAR,
                );
                resetCorporateSettingsCache();
                this.$toast?.success?.(this.t.empresa.saved)
                    || alert(this.t.empresa.saved);
            } catch (e) {
                alert(this.t.common.error);
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>

<style scoped>
@import '@/css/weeduc/admin/corporate.css';

.corporate-settings-section {
    text-align: left;
}

.corporate-settings-page .corporate-section-label {
    margin: 2rem 0 1rem;
}

.corporate-settings-page .corporate-section-label:first-child {
    margin-top: 0;
}

.corporate-settings-row {
    row-gap: 1rem;
    margin-bottom: 0.25rem;
}

.corporate-settings-banner {
    padding: 0.9rem 1rem;
    margin-bottom: 1rem;
    border-radius: 12px;
    background: #eef0fc;
    color: #160266;
    font-size: 0.875rem;
    font-weight: 600;
}

.dashboard.dark .corporate-settings-banner {
    background: rgba(165, 180, 252, 0.12);
    color: #c4b5fd;
}
</style>
